import * as m from '../bridge-methods';
import { createBridgeAction } from '../bridge-actions';

export const logOut = createBridgeAction(m.LOG_OUT);
export const getSession = createBridgeAction(m.GET_SESSION);



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/session/actions.js